import React, { Component } from 'react';
import { Container } from '@mui/material';
import { NavMenu } from './NavMenu';
import Footer from './Footer';

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div>
        <NavMenu />
        <Container maxWidth={'100%'} disableGutters={true}>
          {this.props.children}
        </Container>
        <Footer />
      </div>
    );
  }
}
